import { FC, useEffect } from 'react'

import { observer } from 'mobx-react-lite'

import { TYPE_TIMER } from 'entities/ticket/models/timer'
import timerFormStore from 'entities/ticket/models/timer/timer-store'

import { addZero } from 'shared/lib/addZero'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const TimerHeader = observer(() => {
  const timerData = timerFormStore.getTimerData(TYPE_TIMER.FORM_PURCHASE)

  useEffect(() => {
    if (!timerData?.isRunning) {
      timerFormStore.startTimer(TYPE_TIMER.FORM_PURCHASE)
    }
  }, [])

  const minutes = addZero(Math.floor((timerData?.timer || 0) / 60))
  const seconds = addZero((timerData?.timer || 0) % 60)
  return (
    <div className={s.timer}>
      {minutes}:{seconds}
    </div>
  )
})

interface Props {
  title: string
  onGoBack?: () => void
  variant?: 'white' | 'grey' | 'transparent'
}

const HeaderPurchase: FC<Props> = ({ title, onGoBack, variant }) => {
  return (
    <HeaderGoBack
      buttonWhite
      title={title}
      variant={variant}
      onGoBack={onGoBack}
      actionRight={<TimerHeader />}
    />
  )
}

export default HeaderPurchase
